export * from "./DoctorsTable";
export * from "./DoctorDetails";
export * from "./UpdateDoctor";
